/*
 * Announcement bar marquee (sections/announcement-bar.liquid, setting "Scrolling marquee").
 *
 * Markup:  [data-announcement-marquee] > .announcement-marquee__track > .announcement-marquee__group > .announcement-marquee__item
 * Without JS / with prefers-reduced-motion the single item stays static and centred.
 * Otherwise the item is repeated until one group is at least as wide as the bar, the group is duplicated
 * and the track is translated by exactly one group width, which makes the loop seamless.
 * Copies are aria-hidden and taken out of the tab order; only the first message is exposed.
 */
(function () {
  if (window.__announcementMarqueeInit) {
    window.__announcementMarqueeInit();
    return;
  }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function hideFromAT(el) {
    el.setAttribute('aria-hidden', 'true');
    el.setAttribute('data-marquee-clone', '');
    el.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (node) {
      node.setAttribute('tabindex', '-1');
    });
  }

  function reset(bar) {
    bar.classList.remove('is-running');
    bar.querySelectorAll('[data-marquee-clone]').forEach(function (node) {
      node.remove();
    });
    bar.querySelectorAll('.announcement-marquee__item').forEach(function (node) {
      node.style.removeProperty('width');
    });
    bar.style.removeProperty('--am-shift');
    bar.style.removeProperty('--am-duration');
  }

  function build(bar) {
    var track = bar.querySelector('.announcement-marquee__track');
    var group = track && track.querySelector('.announcement-marquee__group');
    var item = group && group.querySelector('.announcement-marquee__item');
    if (!item) return;

    reset(bar);
    if (reduceMotion.matches) return;

    // measure in the running layout (nowrap, gap after every item)
    bar.classList.add('is-running');
    var itemWidth = item.getBoundingClientRect().width;
    var barWidth = bar.getBoundingClientRect().width;
    if (!itemWidth || !barWidth) {
      bar.classList.remove('is-running');
      return;
    }

    // whole-pixel items, so the copy that takes over at the wrap is rendered on the same pixel grid
    itemWidth = Math.ceil(itemWidth);
    item.style.width = itemWidth + 'px';

    var copies = Math.min(Math.ceil(barWidth / itemWidth), 50);
    for (var i = 1; i < copies; i++) {
      var copy = item.cloneNode(true);
      hideFromAT(copy);
      group.appendChild(copy);
    }

    var groupCopy = group.cloneNode(true);
    hideFromAT(groupCopy);
    track.appendChild(groupCopy);

    var shift = group.getBoundingClientRect().width;
    var speed = parseFloat(bar.getAttribute('data-speed')) || 40;
    bar.style.setProperty('--am-shift', shift + 'px');
    bar.style.setProperty('--am-duration', (shift / speed) + 's');
    bar.__marqueeWidth = barWidth;
  }

  function init() {
    document.querySelectorAll('[data-announcement-marquee]').forEach(function (bar) {
      if (bar.__marqueeReady) return;
      bar.__marqueeReady = true;

      build(bar);

      if ('ResizeObserver' in window) {
        var timer;
        new ResizeObserver(function () {
          // only the bar width matters; ignore the height change caused by our own rebuild
          if (Math.abs(bar.getBoundingClientRect().width - (bar.__marqueeWidth || 0)) < 1 && bar.classList.contains('is-running')) return;
          clearTimeout(timer);
          timer = setTimeout(function () { build(bar); }, 150);
        }).observe(bar);
      }

      // web fonts change the text width
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { build(bar); });
      }
    });
  }

  window.__announcementMarqueeInit = init;

  var onMotionChange = function () {
    document.querySelectorAll('[data-announcement-marquee]').forEach(build);
  };
  if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', onMotionChange);
  else if (reduceMotion.addListener) reduceMotion.addListener(onMotionChange);

  // the script tag sits right after the bar, so build straight away (no static -> scrolling flash);
  // DOMContentLoaded covers bars that are parsed later
  init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);

  // theme editor
  document.addEventListener('shopify:section:load', init);
})();
